import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Index',
    redirect: '/home',
    component: () => import('../views/index/index.vue'),
    children:[
      {
        path: '/home',
        name: 'Home',
        
        component: () => import('../views/home/index.vue'),
      },
      {
        path: '/about',
        name: 'About',
        
        component: () => import('../views/about/index.vue'),
      },
      {
        path: '/recruit',
        name: 'Recruit',
        
        component: () => import('../views/recruit/index.vue'),
      },
      {
        path: '/product',
        name: 'Product',
        
        component: () => import('../views/product/index.vue'),
      },
      {
        path: '/contact',
        name: 'Contact',
        
        component: () => import('../views/contact/index.vue'),
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
